import { h } from "preact";
import { replaceVariables } from "../../config/germanVariables.js";
import { format } from "date-fns";

import i18n from "../../i18n.js";
import Button from "../Button.jsx";
import Hint from "../Hint.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import { getText, getValue, renderHtml } from "../../helpers.js";
import QualificationDisplay from "../QualificationDisplay.jsx";

const LegalProduct = ({ children, onNext, onRestart }) => {
  // TODO: The done button should be a .start_evaluation button and done should be
  //       secondary on second look. But we don't know that yet.
  return (
    <section class="task-page">
      <HeaderIcon>eligibility_checker</HeaderIcon>
      <div class="task-page__content">{children}</div>

      <div class="task-page__buttons">
        <Button onClick={onNext}>{i18n.t("actions.done")}</Button>

        <Button text onClick={onRestart}>
          {i18n.t("actions.discard_result")}
        </Button>
      </div>
    </section>
  );
};

export default {
  with_germany_resicency_permit: (props) => {
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">Residence permit</h1>

        <p class="t-body3">
          {i18n.t(
            "component.talent_details.b2c.with_germany_resicency_permit",
            {
              german_residency_title: getText(
                props.answers.germanResidencyTitle
              ),
              german_residency_expiry_date: format(
                new Date(getValue(props.answers.germanResidencyExpiryDate)),
                "MMMM dd, yyyy"
              ),
            }
          )}
        </p>
      </LegalProduct>
    );
  },

  with_long_term_germany_resicency_permit: (props) => {
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">Residence permit</h1>

        <p class="t-body3">
          {i18n.t(
            "component.talent_details.b2c.with_long_term_germany_resicency_permit",
            {
              german_residency_title: getText(
                props.answers.germanResidencyTitle
              ),
              german_residency_expiry_date: format(
                new Date(getValue(props.answers.germanResidencyExpiryDate)),
                "MMMM dd, yyyy"
              ),
            }
          )}
        </p>
      </LegalProduct>
    );
  },

  legal_requirement_check_eu: (props) => {
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">Freedom of movement</h1>
        <p class="t-body3">
          Based on the information provided, you match the requirements of
          immigrating to Germany.
        </p>
        <p class="t-body3">
          You may enter and stay in Germany without a visa due to the free
          movement of persons. All you need for your entry is a valid identity
          card or comparable proof of identity.
        </p>
        <p class="t-body3">
          Do you want to learn more? Close this task and start your relocation
          process.
        </p>
      </LegalProduct>
    );
  },

  legal_requirement_check_swiss: (props) => {
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">Freedom of movement</h1>

        <p class="t-body3">
          Based on the information provided, you match the requirements of
          immigrating to Germany.
        </p>
        <p class="t-body3">
          You may enter and stay in Germany without a visa due to the free
          movement of persons. All you need for entry is a valid identity card
          or comparable proof of identity.
        </p>
        <p class="t-body3">
          Do you want to learn more? Close this task and start your relocation
          process.
        </p>
      </LegalProduct>
    );
  },

  legal_requirement_check_blue_card: (props) => {
    let text = "";
    switch (props.productId) {
      case "§18g_blue_card":
        text =
          "You may most likely qualify for a Blue Card EU (§ 18g para 1 sentence 1). This residence title is for qualified academic professionals in a position commensurate with their qualifications and a designated minimum remuneration of [Mindestgehaltsgrenze].";
        break;
      case "§18g_blue_card_1_2_1":
        text =
          "You may most likely qualify for a Blue Card EU (§ 18g para 1, sentence 2 No. 1). This residence title is for physicians, engineers, natural scientists, mathematicians, and IT specialists if their annual salary meets or exceeds [Mindestgehaltsgrenze Mangelberuf].";
        break;
      case "§18g_blue_card_1_2_2":
        text =
          "You may most likely qualify for a Blue Card EU (§ 18g para 1, sentence 2 No. 2). This residence title is for young professionals who have obtained any academic degree within the last three years if their annual salary meets or exceeds [Mindestgehaltsgrenze Mangelberuf].";
        break;
      case "§18g_blue_card_1_5":
        text =
          "You may most likely qualify for a Blue Card EU (§ 18g para 1, sentence 5). This residence title is for skilled workers who have completed a 3-year tertiary education program if their annual salary meets or exceeds [Mindestgehaltsgrenze Mangelberuf].";
        break;
      case "§18g_blue_card_2":
        text =
          "You may most likely qualify for a Blue Card EU (§ 18g para 2). This residence title is for skilled IT workers with at least three years of work experience within the last seven years, even without a formal academic qualification. The annual salary must meet or exceed [Mindestgehaltsgrenze Mangelberuf].";
        break;
    }
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">EU Blue Card</h1>

        <p class="t-body3">
          Based on the information provided, you match the requirements of
          immigrating to Germany.
        </p>
        <p class="t-body3">{replaceVariables(text)}</p>
        <p class="t-body3">
          Nioomi will now evaluate the best and most promising approach to
          entering Germany.
        </p>

        <Hint icon="residency_permit_checker">
          {renderHtml(
            replaceVariables(
              "If you have your qualification recognized and a job contract with a minimum salary of [Mindestgehaltsgrenze], then you can apply for an EU Blue Card."
            )
          )}
        </Hint>

        <QualificationDisplay />

        <p class="t-body3">
          Do you want to learn more? Close this task and start your relocation
          process.
        </p>
      </LegalProduct>
    );
  },

  legal_requirement_check_occupation: (props) => {
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">Work visa for qualified professionals</h1>
        <p class="t-body3">
          Based on the information provided, you match the requirements of
          immigrating to Germany.
        </p>
        <p class="t-body3">
          Nioomi will now evaluate the best and most promising approach to
          entering Germany.
        </p>
        <p class="t-body3">
          You may most likely apply for the work visa for qualified
          professionals.
        </p>
        <Hint icon="residency_permit_checker">
          If you already have a recognized qualification such as a university
          degree or vocational qualification, and you already have a job
          contract, then you can apply for a residence permit for employment
          purposes.
        </Hint>
        <QualificationDisplay />
        <p class="t-body3">
          Do you want to learn more? Close this task and start your relocation
          process.
        </p>
      </LegalProduct>
    );
  },

  legal_requirement_check_clerks: (props) => {
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">Visa for IT professionals</h1>

        <p class="t-body3">
          Based on the information provided, you match the requirements of
          immigrating to Germany.
        </p>
        <p class="t-body3">
          Nioomi will now evaluate the best and most promising approach to
          entering Germany.
        </p>
        <p class="t-body3">
          You may most likely apply for a visa for IT professionals.
        </p>

        <Hint icon="residency_permit_checker">
          {replaceVariables(`
            To work in the IT sector in Germany, you do not need to have a recognized degree 
            if you have been working elsewhere for at least three years within the last seven 
            years. You need a job offer in Germany that pays you 
            [Mindestgehaltsgrenze IT-Fachkräfte ohne Ausbildung] before taxes or more.
          `)}
        </Hint>

        <QualificationDisplay />

        <p class="t-body3">
          Do you want to learn more? Close this task and start your relocation
          process.
        </p>
      </LegalProduct>
    );
  },

  legal_requirement_check_qualifications: (props) => {
    return (
      <LegalProduct {...props}>
        <h1 class="t-h5 t-h5--margin">
          Visa for the recognition of foreign qualifications
        </h1>

        <p class="t-body3">
          Based on the information provided, you match the requirements of
          immigrating to Germany.
        </p>
        <p class="t-body3">
          Nioomi will now evaluate the best and most promising approach to
          entering Germany.
        </p>
        <p class="t-body3">
          You may most likely apply for the visa for the recognition of foreign
          qualifications.
        </p>

        <Hint icon="residency_permit_checker">
          If your vocational qualification is not fully recognized, you can get
          the extra qualifications in Germany while already working.
          <br />
          Once you have completed your additional training, you can get your
          qualification fully recognized and apply for a long-term residence
          permit to work.
        </Hint>

        <p class="t-body3">
          Do you want to learn more? Close this task and start your relocation
          process.
        </p>
      </LegalProduct>
    );
  },

  legal_requirement_check_not_mvp: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>eligibility_checker</HeaderIcon>
        <h1 class="task-page__headline">Coming soon.</h1>

        <div class="task-page__content">
          <p>
            Based on the information provided, you presumably match the
            requirements of immigrating to Germany.
            <br />
            <br />
            We are working hard to offer your immigration process soon as well.
            <br />
            <br /> Do you want to get informed? Close this task and put yourself
            on the waiting list.
          </p>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
